module.exports = __webpack_public_path__ + "img/BG_yellow.b026971d.gif";